import React from "react";
import classnames from "classnames";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next/";
import { StyledButton } from "@aureskonnect/react-ui";

import store, {
    setCashManagements,
    setSelectedPeripherals,
    setCheckModificationEffect,
} from "../../store";
import { store as useStore } from "../../../../PeripheralConfigure/MoneticPeripheralConfigure/store";
import { store as layoutStore } from "@components/VerticalLayout/store";
import { PERIPHERAL_TYPE_CASH_MANAGEMENT } from "@constants/index";

export default function CashManagementActionColumn({
    rowData,
    element,
    isDataCashManagementUpdated,
}: any) {
    const { t } = useTranslation();
    const { cashManagements, editedSelectedRows } = useSnapshot(store);
    const { dataTable } = useSnapshot(useStore);
    const { oneShop } = useSnapshot(layoutStore);
    const isMultiAssociate = editedSelectedRows.length > 1;

    const [isSelected, setIsSelected] = React.useState<boolean>(false);

    function isSelectedCashManagement() {
        let isSelectedCashManagement: any[] = [];
        const cashManagementIds = new Set(
                cashManagements.map((item) => item.Id)
            );
        dataTable.forEach((element: any) => {
            if (rowData[0].shopId !== element.shopId) return;
            for (const el of element.subRows) {
                const rows = oneShop ? [el] : el.subRows;

                if (!rows) continue;

                for (const row of rows) {
                    if (
                        row.peripheralType ===
                            PERIPHERAL_TYPE_CASH_MANAGEMENT &&
                        !cashManagementIds.has(row.peripheralId)
                    ) {
                        isSelectedCashManagement.push(row);
                    }
                }
            }
        });
        return isSelectedCashManagement;
    }

    const cashManagementList: any[] = isSelectedCashManagement();

    React.useEffect(() => {
        // Skip pre-selection in multi-association mode: same rationale as
        // MoneticsActionColumn. Pre-populating `cashManagements` here would
        // also trip the save-time guard in PrepheralCardFooter that blocks
        // any multi-save when `cashManagements.length > 0`.
        if (isMultiAssociate) return;

        if (rowData !== undefined && rowData[0].subRows !== undefined) {
            rowData[0].subRows.forEach((el: any) => {
                if (
                    element.Id === el.peripheralId ||
                    cashManagements.some((item) => item.Id === element.Id)
                ) {
                    setCashManagements(element);
                    setIsSelected(true);
                }
            });
        }
        // eslint-disable-next-line
    }, [rowData, isDataCashManagementUpdated]);

    const isCurrentSelected = cashManagements.some(
        (item) => item.Id === element.Id
    );
    const isAlreadyAssociatedElsewhere = cashManagementList.some(
        (item) => item.peripheralId === element.Id
    );
    const currentAppAssociatedId:
        | string
        | undefined = rowData?.[0]?.subRows?.find(
        (el: any) => el.peripheralType === PERIPHERAL_TYPE_CASH_MANAGEMENT
    )?.peripheralId;
    const isCurrentAppAssociated = currentAppAssociatedId === element.Id;
    const isDisabled =
        isMultiAssociate ||
        (!isCurrentSelected && cashManagements.length === 1) ||
        (isAlreadyAssociatedElsewhere && !isCurrentAppAssociated);

    return (
        <StyledButton
            rounded
            outline
            variant={isCurrentSelected ? "danger" : "light"}
            className={`${classnames("button-style-select___clz", {
                "not-allowed-icon__clz": isDisabled,
            })}`}
            onClick={() => {
                if (isDisabled) return;
                setCashManagements(element);
                setSelectedPeripherals(element);
                setIsSelected(!isSelected);
                setCheckModificationEffect(true);
            }}
        >
            <span>{isCurrentSelected ? t("Deselect") : t("Select")}</span>
        </StyledButton>
    );
}
